import axios from 'axios'

const http = axios.create({
    baseURL: '/end',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('magis_access_token')}`,
    },
})

// http.interceptors.request.use(
//     config => {
//         // console.log(config)
//         const token = localStorage.getItem('access_tokenasdfasdf')
//         if (token) {
//             config.headers.common.Authorization = token
//         }
//         return config
//     },
//     error => {
//         return Promise.reject(error)
//     },
// )

http.interceptors.response.use(
    response => {
      if (response.status === 200 || response.status === 201) {
        return Promise.resolve(response)
      } else {
        return Promise.reject(response)
      }
    },
  error => {
      if (error.message === 'Network Error') {
        // alert('Erro ao conectar com a internet')
        return Promise.reject(error)
      }
      if (error.response.status) {
        switch (error.response.status) {
          case 400:
            console.log(error.response.data.errors)
            break
        //   case 401:
        //     alert('session expired')
        //     break
        //   case 403:
        //     router.replace({
        //       path: '/login',
        //       query: { redirect: router.currentRoute.fullPath },
        //     })
        //      break
        //   case 404:
        //     alert('page not exist')
        //     break
        //   case 502:
        //    setTimeout(() => {
        //       router.replace({
        //         path: '/login',
        //         query: {
        //           redirect: router.currentRoute.fullPath,
        //         },
        //       })
        //     }, 1000)
        }
        return Promise.reject(error.response)
      }
    },
  )

export default http
